import React from "react";
import { Form, Formik } from "formik";
import { useHistory } from "react-router-dom";

import ROUTES from "@config/routes";
import Layout from "@components/Layout";
import Title from "@components/Title";

import UserForm from "../shared/ui/UserForm";
import FormEditUserValidationSchema from "./validation";
import { useSubmitEditUser } from "./useSubmitEditUser";

const EditUserPage: React.FC = () => {
  const history = useHistory();
  const { loading, initialValues, handleSubmit, hasUser } = useSubmitEditUser();

  if (!hasUser) {
    history.push(ROUTES.ADMIN_ROUTES.HOME);
    return null;
  }

  return (
    <Layout>
      <div style={{ gridArea: "content" }}>
        <Title title="Editar Usuário" />
        <Formik
          initialValues={initialValues!}
          validationSchema={FormEditUserValidationSchema}
          onSubmit={handleSubmit}
        >
          <Form style={{ margin: "0" }}>
            <UserForm
              loading={loading}
              title="Dados do usuário"
              submitLabel="Salvar"
              submitLoadingLabel="Salvando..."
              onCancel={() => history.push(ROUTES.ADMIN_ROUTES.LIST_USERS)}
            />
          </Form>
        </Formik>
      </div>
    </Layout>
  );
};

export default EditUserPage;
